// Mirror of @theme tokens in app.css. Update both sides together when a token changes.
// Used by SVG attributes (fill="…", stroke="…") that cannot consume CSS variables in static
// contexts such as prerender output and <marker> definitions.
export const SVG_COLORS = {
  // Neutrals
  surface:         "#FFFFFF",   // --color-surface
  paper:           "#F5F7FA",   // --color-secondary (node card fill)
  border:          "#E3E7ED",   // --border
  neutral300:      "#B4BCC7",
  neutral600:      "#4A5361",   // --foreground-muted
  foreground:      "#11161D",   // --foreground
  dividerLabel:    "#3A4250",   // a touch darker than neutral600 for label confidence
  // Brand / interactive
  primary:         "#2F6B63",   // --primary (sage)
  // Status
  drift:           "#B07D1A",   // status / warn — copy edge
  driftText:       "#9C2621",   // --error-text — drift text — AA-safe on white
  warningText:     "#8A5F13",   // warning text — AA-safe on white
  risk:            "#C2362E",   // --error — status / danger — drift edge
} as const;

export type SvgColor = keyof typeof SVG_COLORS;
